module.exports = __webpack_public_path__ + "img/full5-min.d8b47c4e.png";